import { useMemo } from "react";
import { connect } from "react-redux";

//Card Name is the header
//Current Data is the current month's numeric value
//Previous Data is the previous month's numeric value
//Period is the time period shown below the header
//ObjectName is optional, and is to be used if you're not comparing a currency
const ComparisonCard = ({ cardName, currentData, previousData, period, objectName, currency }) => {
	const data = useMemo(() => {
		//If there is no previous month, return null
		if (!previousData || !currentData) return null;

		const difference = currentData - previousData;
		const percentageDifference = (difference / previousData) * 100;

		const change = {
			difference: difference.toFixed(2),
			percentage: percentageDifference.toFixed(2),
		};

		return change;
	});

	return (
		<>
			<div
				className="form-grid col-3 p-3 pb-0"
				style={{
					borderLeft: `5px solid ${data.difference < 0 ? "#dc3545" : "#28a745"}`,
					borderRadius: "0.5rem",
					backgroundColor: "white",
					fontSize: "2rem",
				}}
			>
				<div
					className="col-span-1 pl-2"
					style={{ fontSize: "1.2rem", color: "#858585" }}
				>
					<div className="pull-left">{cardName || ""}</div>
					<br />
					<div className="pull-left">{period || ""}</div>
				</div>
				<div className="col-span-2 pr-1">
					<div
						style={{ fontSize: "1.8rem", color: "#4a4a4a" }}
						className="pull-right"
					>{`${data.percentage < 0 ? "-" : "+"}${Math.abs(data.percentage)}%`}</div>
					<br />
					<div className="pull-right">
						{objectName
							? `${data.difference < 0 ? "-" : "+"}${Math.abs(data.difference).toFixed(0)} ${String(objectName)}`
							: `${data.difference < 0 ? "-" : "+"}${currency}${Math.abs(data.difference)}`}
					</div>
				</div>
			</div>
		</>
	);
};

const mapStateToProps = (state) => {
	const jurisdiction = state?.advisors?.settings?.jurisdiction;
	const jurisdictionList = state.jurisdictions;

	const currency = jurisdictionList?.find((j) => j.countryCode === jurisdiction)?.currency;

	return {
		currency,
	};
};

const mapDispatchToProps = (dispatch) => {};

export default connect(mapStateToProps, mapDispatchToProps)(ComparisonCard);
